import ProductCard from '../../components/ProductCard'

export type ProductTeaserProps = {
  readonly title: string
  readonly description: string
  readonly productsUrl: string
  readonly products: Array<Parameters<typeof ProductCard>[number]>
}

/**
 * This component renders a hero with a list of products, a title and description.
 * @param products the list of products to render
 * @param products_link the url to go to when clicking on "all products"
 * @param description description to render
 * @param title title to render
 */
export default function ProductTeaser({
  products,
  productsUrl,
  description,
  title,
}: ProductTeaserProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
      <div style={{ maxWidth: '500px' }}>
        <h2>{title}</h2>

        <p>{description}</p>

        <a href={productsUrl}>Alle Produkte</a>
      </div>

      <ul>
        {products.map((productProps, i) => (
          <li key={productProps.data?.variantId ?? i}>
            <ProductCard {...productProps} />
          </li>
        ))}
      </ul>
    </div>
  )
}
